if (!customElements.get('mobile-dock')) {
  customElements.define('mobile-dock', class MobileDock extends HTMLElement {
    static scrollState(y, anchor, down) {
      if (y <= 80) return { anchor: y, down: false };
      if (Math.abs(y - anchor) < 8) return { anchor, down };
      return { anchor: y, down: y > anchor };
    }

    static visibility({ mobile, y, down, blocked, hasBuybar, buttonBottom, boundaryTop, viewportHeight }) {
      return {
        dock: mobile && !blocked && y > 80 && down,
        buybar: mobile && !blocked && hasBuybar && buttonBottom < 0 && boundaryTop <= viewportHeight,
        top: mobile && !blocked && y > 320
      };
    }

    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.anchor = Math.max(0, window.scrollY);
      this.down = this.anchor > 80;
      this.section = this.closest('.mobile-dock-section');
      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.refresh = () => {
        this.resizeObserver?.disconnect();
        this.buybar = document.querySelector('#MainContent [data-drv-mobile-buybar]');
        const formId = this.buybar?.getAttribute('form');
        this.form = formId ? document.getElementById(formId) : null;
        this.mainButton = this.form ? [...document.querySelectorAll('button.product-form__submit')].find(b => b.form === this.form) : null;
        this.boundary = this.buybar?.closest('.section')?.querySelector('[data-product-sticky-boundary]');
        this.resizeObserver = new ResizeObserver(this.queue);
        this.resizeObserver.observe(this);
        if (this.buybar?.firstElementChild) this.resizeObserver.observe(this.buybar.firstElementChild);
        this.queue();
      };
      window.addEventListener('scroll', this.queue, { ...options, passive: true });
      window.addEventListener('resize', this.queue, options);
      window.addEventListener('pageshow', this.refresh, options);
      this.mobile.addEventListener('change', this.queue, options);
      document.addEventListener('focusin', this.queue, options);
      document.addEventListener('focusout', this.queue, options);
      document.addEventListener('shopify:section:load', this.refresh, options);
      document.addEventListener('shopify:section:unload', this.refresh, options);
      window.visualViewport?.addEventListener('resize', this.queue, options);
      this.modalObserver = new MutationObserver(this.queue);
      this.modalObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.setAttribute('loaded', '');
      document.documentElement.setAttribute('data-drv-mobile-ui-ready', '');
      this.refresh();
    }

    update() {
      if (!this.isConnected) return;
      const y = Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight));
      const next = this.constructor.scrollState(y, this.anchor, this.down);
      this.anchor = next.anchor;
      this.down = next.down;
      const editing = document.activeElement?.matches('input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]), textarea, select, [contenteditable=true]');
      const blocked = document.body.classList.contains('has-modal-open') || document.body.classList.contains('has-modal-opening') || editing;
      const state = this.constructor.visibility({
        mobile: this.mobile.matches, y, down: this.down, blocked,
        hasBuybar: !!(this.buybar && this.form && this.boundary && this.mainButton),
        buttonBottom: this.mainButton?.getBoundingClientRect().bottom ?? Infinity,
        boundaryTop: this.boundary?.getBoundingClientRect().top ?? Infinity,
        viewportHeight: window.innerHeight
      });
      const html = document.documentElement;
      html.toggleAttribute('data-drv-dock-visible', state.dock);
      this.inert = !state.dock;
      this.section?.classList.toggle('active', state.dock);
      const dockHeight = this.mobile.matches ? this.getBoundingClientRect().height : 0;
      html.style.setProperty('--mobile-dock-height', dockHeight + 'px');
      html.style.setProperty('--drv-dock-offset', (state.dock ? dockHeight : 0) + 'px');
      if (this.buybar) {
        this.buybar.toggleAttribute('data-drv-buybar-visible', state.buybar);
        this.buybar.inert = !state.buybar;
      }
      const buybarHeight = state.buybar ? this.buybar.firstElementChild.getBoundingClientRect().height : 0;
      html.style.setProperty('--drv-buybar-height', buybarHeight + 'px');
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.modalObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      document.documentElement.removeAttribute('data-drv-mobile-ui-ready');
      document.documentElement.removeAttribute('data-drv-dock-visible');
      document.documentElement.style.setProperty('--drv-dock-offset', '0px');
      document.documentElement.style.setProperty('--drv-buybar-height', '0px');
    }
  }, { extends: 'nav' });
}
